import * as calendar from './calendar'
import { serviceOptionsMap } from './options'

const install = function (Vue, options = {}) {
  const $config = {
    brand: 'simon',
    calendar,
    serviceOptionsMap,
    ...options
  }

  Vue.mixin({
    computed: {
      $config () {
        return $config
      }
    }
  })
}

export default {
  install
}
